import { graphql, Link, useStaticQuery } from "gatsby"
import { Button, Dropdown, Menu } from "semantic-ui-react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import PricingModal from "./Shared/PricingModal"

const styles = {
  menuItem: {
    margin: "auto",
  },
}

const Desktop = ({ image }) => {
  return (
    <nav>
    <Menu
      fixed={"top"}
      secondary
      borderless
      pointing
      style={{
        paddingLeft: "2em",
        paddingRight: "2em",
        backgroundColor: "#FFF",
      }}
    >
      <Menu.Item header as={Link} to="/">
        <GatsbyImage image={getImage(image)} alt="ArtCollection.io Logo" />
      </Menu.Item>
      <Menu.Menu position={"right"}>
        <Menu.Item
          style={styles.menuItem}
          as={Link}
          content={"About Us"}
          to={"/about"}
        />
        <Dropdown item text={"Features"} style={styles.menuItem}>
          <Dropdown.Menu>
            <Dropdown.Item
              style={styles.menuItem}
              as={Link}
              content={"Inventory Management"}
              to={"/inventory-management"}
            />
            <Dropdown.Item
              style={styles.menuItem}
              as={Link}
              content={"Art Market Alerts"}
              to={"/art-market-alerts"}
            />
            <Dropdown.Item
              style={styles.menuItem}
              as={Link}
              content={"Auction Database"}
              to={"/auction-results-database"}
            />
            <Dropdown.Item
              style={styles.menuItem}
              as={Link}
              content={"Instant Valuation"}
              to={"/valuation"}
            />
            <Dropdown.Item
              style={styles.menuItem}
              as={Link}
              content={"Financial Reporting"}
              to={"/financial-reporting"}
            />
          </Dropdown.Menu>
        </Dropdown>
        <PricingModal>
          <Menu.Item style={styles.menuItem} content={"Pricing"} />
        </PricingModal>
        <Menu.Item
          style={styles.menuItem}
          as={Link}
          content={"Blog"}
          to={"/blog"}
        />
        <Menu.Item>
          <Button
            basic
            content={"Log in"}
            as={Link}
            to={"https://app.artcollection.io/login"}
          />
          <Button
            color={"black"}
            content={"Sign Up"}
            as={Link}
            to={"https://app.artcollection.io/register"}
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
    </nav>
  )
}

const Mobile = ({ image }) => {
  return (
    <nav>
    <Menu
      fixed={"top"}
      secondary
      borderless
      pointing
      style={{
        backgroundColor: "#FFF",
      }}
    >
      <Menu.Item header as={Link} to="/">
        <GatsbyImage image={getImage(image)} alt="ArtCollection.io Logo" />
      </Menu.Item>
      <Menu.Menu position={"right"}>
        <Menu.Item>
          <Button
            basic
            content={"Log in"}
            as={Link}
            to={"https://app.artcollection.io/login"}
          />
          <Button
            color={"black"}
            content={"Sign Up"}
            as={Link}
            to={"https://app.artcollection.io/register"}
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
    </nav>
  )
}

export default ({ isMobile }) => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "logos/full_logo_black.png" }) {
        childImageSharp {
          gatsbyImageData(width: 100)
        }
      }
    }
  `)
  return isMobile ? Mobile(data) : Desktop(data)
}
